import type { FormField } from '../telegram/DynamicFormFields';
import { parseClockToSeconds } from './timeResult';

export function getMainResultField(fields: FormField[]): FormField | null {
  return (fields.find((f) => (f as any).main_result_field) || fields.find((f) => (f as any).result_field) || null) as any;
}

export function isTimeDataType(field: FormField | null | undefined): boolean {
  return String((field as any)?.data_type ?? '').toLowerCase() === 'time';
}

// Applies the correct transformation for /telegram/new-ranking endpoint.
export function normalizeNewResultForRanking(opts: {
  fields: FormField[];
  requiredResult: unknown;
}): number | null {
  const main = getMainResultField(opts.fields);
  const isTime = isTimeDataType(main);
  if (isTime) {
    return parseClockToSeconds(opts.requiredResult);
  }
  const v = typeof opts.requiredResult === 'number' ? opts.requiredResult : Number(String(opts.requiredResult ?? '').trim());
  return Number.isFinite(v) ? v : null;
}
